import { ChatMessageEvent, IChatMessage } from "store/messages/messages.state";

export const handleReceipts = async (message: IChatMessage, session: connect.CustomerChatSession) => {

    if (!["text/plain", "text/markdown"].includes(message.contentType)) return message;

    if (message.role !== "AGENT") return message;        
    
    session.sendEvent({
        content: JSON.stringify({ messageId: message.id }),
        //@ts-ignore
        contentType: ChatMessageEvent.MESSAGE_DELIVERED,
    });

    return message;

}